import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { FeaturesGrid } from '../components/FeaturesGrid';
import { BenefitsSection } from '../components/BenefitsSection';
import { BonusCards } from '../components/BonusCards';
import { ContentPreview } from '../components/ContentPreview';
import { PricingSection } from '../components/PricingSection';
import { Testimonials } from '../components/Testimonials';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-white font-sans text-gray-900" data-id="element-190">
      <Hero data-id="element-191" />
      <ProblemSection data-id="element-192" />
      <SolutionSection data-id="element-193" />
      <FeaturesGrid data-id="element-194" />
      <BenefitsSection data-id="element-195" />
      <BonusCards data-id="element-196" />
      <ContentPreview data-id="element-197" />
      <PricingSection data-id="element-198" />
      <Testimonials data-id="element-199" />
      <Guarantee data-id="element-200" />
      <FAQ data-id="element-201" />
      <Footer data-id="element-202" />
    </main>;
}